import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Server, Shield, Wifi, Monitor, Cloud } from 'lucide-react';
import { mockServices } from '../mock';

const iconMap = {
  Server,
  Shield,
  Wifi,
  Monitor,
  Cloud
};

const colorMap = {
  blue: 'text-[#2563EB]',
  purple: 'text-[#4A2B7F]',
  cyan: 'text-[#06B6D4]'
};

const ServicesSection = () => {
  return (
    <section id="servicos" className="py-16 md:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nossos Serviços
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Soluções completas em TI para empresas que buscam excelência, segurança e
            performance em sua infraestrutura tecnológica.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="relative overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-none bg-white"
              >
                {/* Background number */}
                <div className="absolute top-4 right-4 text-6xl font-bold text-gray-100 select-none">
                  {service.number}
                </div>

                <CardHeader className="relative z-10">
                  <div className={`w-12 h-12 mb-4 ${colorMap[service.color]}`}>
                    <IconComponent className="w-full h-full" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10">
                  <CardDescription className="text-gray-600 text-base">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;